import {
	DataList,
	PageWrapper,
	Paragraph,
	TableFilter,
} from '@welbe/web-design-system';
import { HStack, Button } from '@welbe/design-system';
import FileSvg from 'App/assets/img/opened_file.svg?url';
import { ModalConfirm } from 'App/Components/ModalConfirm/ModalConfirm';
import { EmployeeButtons } from './components/EmployeeButtons';
import { ModalInactiveEmployee } from './components/ModalInactiveEmployee/ModalInactiveEmployee';

import { Container, LayoutPage } from './Employees.styles';

import { useEmployees } from './Employees.hooks';

import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import { formattedRows } from './Builder';
import { EmployeeFilters } from './components/EmployeeFilters/EmployeeFilters';
import { ModalAssignJobProfile } from './components/ModalAssignJobProfile/ModalAssignJobProfile';
import { columns } from './Employees.enums';
import { FiDownloadCloud } from 'react-icons/fi';
import { ModalHandler } from './components/Modals/ModalHandler';
import { MergeEmployeesDialog } from './components/MergeEmployeesDialog/MergeEmployeesDialog';
import { ModalPreventEnableEmployee } from './components/ModalPreventEnableEmployee/ModalPreventEnableEmployee';

export const Employees = (): JSX.Element => {
	const {
		currentUser,
		isLoadingBranchOffice,
		branchOfficeOptions,
		isLoadingAction,
		selectedEmployees,
		isOpenDrawer,
		data,
		loading,
		totalPages,
		currentPage,
		showModalInactiveEmployee,
		hasOnlyActive,
		hasOnlyInactive,
		confirmModal,
		isBroker,
		isLoadingJobProfile,
		risksProfile,
		expositionAreas,
		openModalMergeEmployee,
		openModalAssignJobProfile,
		isFilterOpen,
		height,
		isOpenAlertModal,
		setOpenAlertModal,
		setIsOpenDrawer,
		setOpenModalMergeEmployee,
		handleOpenModalMergeEmployee,
		handleDownloadCsv,
		handleToggleStatusEmployee,
		handleShowModalInactiveEmployee,
		handleCloseModalInactiveEmployee,
		handleEditEmployee,
		handleOpenModalAssignJobProfile,
		handleCloseModalAssignJobProfile,
		handleAssignJobProfile,
		setFilterOpen,
		handleSearch,
		handleFilters,
		handleChangePage,
		handleSelectEmployees,
		filters,
	} = useEmployees();

	useAnalyticsOpenScreen({
		context: 'employee',
		trackName: 'Open Employee List',
		analyticProps: { isBroker },
	});

	return (
		<PageWrapper
			icon={
				<img
					src={FileSvg}
					width="30px"
					height="30px"
					alt="Icono de colaboradores"
					color="#b2b6c0"
				/>
			}
			title="Colaboradores"
			slotHeader={
				<HStack>
					<Button size="sm" onClick={handleDownloadCsv}>
						Descargar CSV <FiDownloadCloud />
					</Button>
					<ModalHandler />
				</HStack>
			}
		>
			<Container>
				<TableFilter
					open={isFilterOpen}
					height={height - 210}
					onSearch={handleSearch}
					filters={filters}
					onClose={() => setFilterOpen(false)}
					onOpen={() => setFilterOpen(true)}
				>
					<EmployeeFilters
						height={height - 210}
						onChangeFilters={handleFilters}
						isLoadingBranchOffice={isLoadingBranchOffice}
						branchOfficeOptions={branchOfficeOptions}
						isLoadingJobProfile={isLoadingJobProfile}
						risksProfile={risksProfile}
						expositionAreas={expositionAreas}
						onSearch={handleSearch}
					/>
				</TableFilter>
				<LayoutPage>
					<DataList
						onSelect={handleSelectEmployees}
						selected={selectedEmployees}
						loading={loading}
						headers={columns}
						currentPage={currentPage}
						pagesNumber={totalPages}
						onChangePage={handleChangePage}
						rows={formattedRows(data)}
						height={`${height - 300}px`}
					/>
				</LayoutPage>
			</Container>

			<EmployeeButtons
				open={isOpenDrawer}
				onClose={() => setIsOpenDrawer(false)}
				sires={currentUser?.company?.companyPortalSettings?.hasSires}
				selectedEmployees={selectedEmployees}
				isLoadingActiveCandidate={isLoadingAction}
				hasOnlyActive={hasOnlyActive}
				hasOnlyInactive={hasOnlyInactive}
				handleEditEmployee={handleEditEmployee}
				handleActiveEmployee={() => handleToggleStatusEmployee('active')}
				handleShowModalInactiveModal={handleShowModalInactiveEmployee}
				handleOpenModalAssignJobProfile={handleOpenModalAssignJobProfile}
				handleMergeEmployee={handleOpenModalMergeEmployee}
			/>

			<MergeEmployeesDialog
				employees={selectedEmployees}
				open={openModalMergeEmployee}
				onClose={(refresh?: boolean) => {
					setOpenModalMergeEmployee(false);
					handleSelectEmployees([]);
					if (refresh) {
						handleSearch();
					}
				}}
			/>

			<ModalPreventEnableEmployee
				open={isOpenAlertModal}
				selectedEmployees={selectedEmployees}
				onClose={setOpenAlertModal}
			/>

			<ModalConfirm
				visible={confirmModal.show}
				onClose={confirmModal.onClose}
				imageUrl={confirmModal.icon}
				message={confirmModal.message}
				height={confirmModal.children ? '220px' : '180px'}
			>
				<>
					{confirmModal.children && (
						<Paragraph padding="15px 0 0 0">{confirmModal.children}</Paragraph>
					)}
				</>
			</ModalConfirm>
			{showModalInactiveEmployee && (
				<ModalInactiveEmployee
					isLoading={isLoadingAction}
					selectedEmployees={selectedEmployees}
					handleInactiveEmployee={() => handleToggleStatusEmployee('inactive')}
					handleClose={handleCloseModalInactiveEmployee}
				/>
			)}
			{openModalAssignJobProfile && (
				<ModalAssignJobProfile
					isLoading={isLoadingAction}
					risksProfile={risksProfile}
					expositionAreas={expositionAreas}
					handleAssignJobProfile={handleAssignJobProfile}
					handleClose={handleCloseModalAssignJobProfile}
				/>
			)}
		</PageWrapper>
	);
};
